import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../redux/projApollo/actions';

class SubmittedForm extends React.Component {
    componentWillUpdate(){
        const { projApollo } = this.props;
    
        if (projApollo.invoiceSubmitted) {
            this.props.invoiceSubmissionCompleted();
        }
    }

    render(){
        return (
            <div className="container">
                <div className="jumbotron centered text-center">
                    <div className="row">
                        <br />
                    </div>
                    <div className="row">
                        <h3>Invoice Data Extraction</h3>
                    </div>
                    <div className="row">
                        <div className="alert alert-success" role="alert">
                            Your task has been submitted successfully.
                        </div>
                    </div>    
                </div>
            </div>
        )
    }
    
}

const mapStateToProps = (state, ownProps) => {
    return {
        projApollo: state.projApollo
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      invoiceSubmissionCompleted: () => {
         dispatch(actions.invoiceSubmissionCompleted())  
      }
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(SubmittedForm);


// WEBPACK FOOTER //
// ./src/views/ProjectApollo/SubmittedForm.js